import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { tracking } from 'src/tracking';
import { initialiseAuthClient } from 'src/utils/online-identity';

import AuthContext from './AuthContext';

interface AuthState {
  authToken: string | undefined;
  xToken: string | undefined;
  authLoaded: boolean;
}

const AuthProvider = ({ children }: { children: any }) => {
  const location = useLocation();
  const { token: userToken } = queryString.parseUrl(location.search).query;

  const [authState, setAuthState] = useState<AuthState>({
    authToken: undefined,
    xToken: (userToken as string) ?? undefined,
    authLoaded: false,
  });

  useEffect(() => {
    const initAuth = async () => {
      const getToken = initialiseAuthClient();
      let token: string | undefined;
      try {
        token = (await getToken()) || undefined;
      } catch {
        // Not actually an error, just means they are not logged in
        token = undefined;
      }

      setAuthState((prev) => ({
        authToken: token,
        xToken: prev.xToken,
        authLoaded: true,
      }));

      tracking.sitewide.auth.login({
        loginStatus: token ? 'logged-in' : 'logged-out',
      });
    };
    // This is currently recommended but one day will be replaced with a new pattern
    // Word from react core maintainer - https://github.com/facebook/react/issues/14326
    initAuth();
  }, []);

  const value = {
    getAuthToken: () => authState.authToken,
    getXToken: () => authState.xToken,
    authLoaded: authState.authLoaded,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
